import { eMaterialType } from '@/types/Materials';
import { z } from 'zod';

export const getMaterialTypesSchema = z.array(
  z.object({
    id: z.string(),
    eType: z.nativeEnum(eMaterialType),
    name: z.string(),
    code: z.string(),
  })
);

export type GetMaterialTypes = z.infer<typeof getMaterialTypesSchema>;
